import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { BRAND } from "@/lib/brand";
import AdminTariffs from "@/components/AdminTariffs";
import AdminVenueEvents from "@/components/admin/AdminVenueEvents";
import AdminMasterCalendar from "@/components/admin/AdminMasterCalendar";
import AdminMobileEvents from "@/components/admin/AdminMobileEvents";
import AdminRequests from "@/components/admin/AdminRequests";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

const TABS = [
  { k: "events", l: "Esdeveniments" },
  { k: "requests", l: "Sol·licituds" },
  { k: "calendar", l: "Calendari d'esdeveniments" },
  { k: "mobile", l: "Gestió Esdeveniments Externs" },
  { k: "tariffs", l: "Tarifes" },
];

export default function AdminDashboardPage() {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState("events");
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    if (!loading && !user) navigate("/admin/login");
  }, [user, loading, navigate]);

  if (loading || !user) {
    return <div className="min-h-screen flex items-center justify-center" data-testid="admin-checking">…</div>;
  }

  const openFromCalendar = (item) => {
    setTab(item.source === "mobile" ? "mobile" : "events");
    setEditId(item.id);
  };
  const clearEdit = () => setEditId(null);

  return (
    <div className="min-h-screen bg-[#fdfcf9] text-[#2A2421]" data-testid="admin-dashboard">
      <header className="border-b border-[#eae0df] bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex items-center justify-between">
          <div className="flex items-center gap-6">
            <Link to="/" className="flex items-center"><img src={BRAND.logoUrl} alt="Aura" className="h-8 brightness-0" /></Link>
            <span className="text-xs uppercase tracking-[0.22em] text-[#5C544F]">Panel admin</span>
          </div>
          <div className="flex items-center gap-4">
            <span className="text-sm text-[#5C544F] hidden md:inline" data-testid="admin-user-email">{user.email}</span>
            <Link to="/manager" data-testid="admin-link-manager" className="text-xs uppercase tracking-[0.16em] px-4 py-2 rounded-full bg-[#101B28] text-[#F7F5F0] hover:bg-[#1d2c3f]">AURA Manager</Link>
            <Button variant="ghost" onClick={async () => { await logout(); navigate("/admin/login"); }}
              data-testid="admin-logout" className="text-sm gap-2">
              <LogOut size={16} /> Sortir
            </Button>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-6 md:px-10 py-10">
        <Tabs value={tab} onValueChange={setTab}>
          <TabsList className="mb-10 h-auto flex-wrap justify-start gap-1 bg-white border border-[#eae0df] rounded-full p-1" data-testid="admin-tabs">
            {TABS.map((t) => (
              <TabsTrigger key={t.k} value={t.k} data-testid={`admin-tab-${t.k}`}
                className="rounded-full px-5 py-2 text-xs uppercase tracking-[0.16em] data-[state=active]:bg-[#3e664c] data-[state=active]:text-white">
                {t.l}
              </TabsTrigger>
            ))}
          </TabsList>
          <TabsContent value="events"><AdminVenueEvents editId={tab === "events" ? editId : null} onEditHandled={clearEdit} /></TabsContent>
          <TabsContent value="calendar"><AdminMasterCalendar onEdit={openFromCalendar} /></TabsContent>
          <TabsContent value="requests"><AdminRequests /></TabsContent>
          <TabsContent value="mobile"><AdminMobileEvents editId={tab === "mobile" ? editId : null} onEditHandled={clearEdit} /></TabsContent>
          <TabsContent value="tariffs"><AdminTariffs /></TabsContent>
        </Tabs>
      </main>
    </div>
  );
}
